const forgetPasswordPage = {
  name: 'forgetPassword',
  path: 'forgetPassword',
  component: resolve => require(['../../components/pages/forgetPassword'], resolve),
  redirect: 'forgetPassword/authorize',
  children: [{
    path: 'authorize',
    component: resolve => require(['../../components/pages/forgetPassword/authorize'], resolve)
  }]
}

export default forgetPasswordPage



// WEBPACK FOOTER //
// ./src/router/pages/forgetPassword.js